import type {Locale} from '../../types';
import en from '../../locales/en.json';
import no from '../../locales/no.json';
import type {CoreTranslate} from './coreTypes';

type masterLocaleStringsType = typeof en;

type LocaleContent = masterLocaleStringsType;

export const Locales: {[loc in Locale]: LocaleContent} = {
  en,
  nb: no as unknown as LocaleContent,
  nn: no as unknown as LocaleContent,
} as const;

export type Translate<TResult = string> = CoreTranslate<
  masterLocaleStringsType,
  TResult
>;

export type LocaleMap = {
  locale: Locale;
  dayjsLocale: ILocale;
  mask: string;
  maskFormat: string;
};
